import React from "react";
import { observer } from "mobx-react";
import { TeamStatistics } from "@gp/models";

export const RedCards = observer(function RedCards({
	homeStats,
	awayStats,
}: {
	homeStats: TeamStatistics | undefined;
	awayStats: TeamStatistics | undefined;
}) {
	if (
		homeStats?.redCards == null &&
		homeStats?.redYellowCards == null &&
		awayStats?.redCards == null &&
		awayStats?.redYellowCards == null
	) {
		return null;
	}

	const homeRedCards = homeStats?.redCards || 0;
	const awayRedCards = awayStats?.redCards || 0;

	const homeRedYellowCards = homeStats?.redYellowCards || 0;
	const awayRedYellowCards = awayStats?.redYellowCards || 0;

	return (
		<div className="event__stats__item">
			<div className="event__stats__icon">
				<i className="u-icon u-icon--sml u-icon--card u-icon--card--red u-align--v--middle" />
			</div>
			<div className="event__stats__value">
				<span>{homeRedCards + homeRedYellowCards}</span>
				<span> - </span>
				<span>{awayRedCards + awayRedYellowCards}</span>
			</div>
		</div>
	);
});
